import { createContext } from "react";
import { OrderTypes } from "@shared/features/trades/common/types";
import { ConfigurationItem } from "@shared/types";

export const GeneralConfigurationContext = createContext<any>({});
export const ModalItemContext = createContext<
  { inModal?: boolean } | undefined
>({});
export const StrategyItemContext = createContext<
  | {
      checkItemSelected: (item: ConfigurationItem) => boolean;
      handleSelectItem: (item: ConfigurationItem) => void;
      handleDeleteItem: (item: ConfigurationItem) => void;
      setEditOrCreateCustomStrategyItem: (item?: ConfigurationItem) => void;
      editOrCreateCustomStrategyItem: ConfigurationItem;
      setEditOrCreateDCAStrategyItem: (item?: ConfigurationItem) => void;
      editOrCreateDCAStrategyItem: ConfigurationItem;
      onSave: () => void;
      customStrategiesItem: ConfigurationItem;
      dcaStrategiesItem: ConfigurationItem;
      customStrategyTemplate: ConfigurationItem;
      dcaStrategyTemplate: ConfigurationItem;
      strategyOrderType: OrderTypes.ENTRY | OrderTypes.TAKE_PROFIT;
      itemToEdit: ConfigurationItem | undefined;
      setItemToEdit: (item: ConfigurationItem | undefined) => void;
    }
  | undefined
>(undefined);
